import {
  adminSupportService,
  type SupportTicketFilters,
} from '@/services/admin-support.service';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useSupportStats() {
  return useQuery({
    queryKey: ['admin-support-stats'],
    queryFn: () => adminSupportService.getStats(),
  });
}

export function useSupportTickets(filters: SupportTicketFilters = {}) {
  return useQuery({
    queryKey: ['admin-support-tickets', filters],
    queryFn: () => adminSupportService.getTickets(filters),
  });
}

export function useSupportTicketDetail(uuid: string | undefined) {
  return useQuery({
    queryKey: ['admin-support-ticket', uuid],
    queryFn: () => adminSupportService.getTicketDetail(uuid!),
    enabled: !!uuid,
  });
}

export function useReplyToTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ uuid, content }: { uuid: string; content: string }) =>
      adminSupportService.reply(uuid, content),
    onSuccess: (_data, variables) => {
      toast.success('Reponse envoyee');
      qc.invalidateQueries({
        queryKey: ['admin-support-ticket', variables.uuid],
      });
      qc.invalidateQueries({ queryKey: ['admin-support-tickets'] });
      qc.invalidateQueries({ queryKey: ['admin-support-stats'] });
    },
    onError: () => toast.error("Erreur lors de l'envoi de la reponse"),
  });
}

export function useUpdateTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      uuid,
      ...data
    }: {
      uuid: string;
      status?: string;
      priority?: string;
    }) => adminSupportService.updateTicket(uuid, data),
    onSuccess: (_data, variables) => {
      toast.success('Ticket mis a jour');
      qc.invalidateQueries({
        queryKey: ['admin-support-ticket', variables.uuid],
      });
      qc.invalidateQueries({ queryKey: ['admin-support-tickets'] });
      qc.invalidateQueries({ queryKey: ['admin-support-stats'] });
    },
    onError: () => toast.error('Erreur lors de la mise a jour'),
  });
}
